import { render, staticRenderFns } from "./AppInput.vue?vue&type=template&id=18045a56&scoped=true"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"
import style0 from "./AppInput.vue?vue&type=style&index=0&id=18045a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18045a56",
  null
  
)

export default component.exports